import { Text } from '../../../components/UI-CHAKRA/Text';
import { ReactComponent as AlertIcon } from '../../../assets/images/icons/mevo/alert.svg';
import { ReactComponent as EditIcon } from '../../../assets/images/icons/mevo/edit.svg';
import { Flex } from '../../../components/UI-CHAKRA/Flex';

interface InteractionBadgeProps {
  onClick(): void;
}

const InteractionBadge = (props: InteractionBadgeProps) => {
  return (
    <Flex
      cursor={'pointer'}
      p={' 20px'}
      w={'100%'}
      border={'1px solid #CED4DA'}
      borderRadius={'10px'}
      alignItems={'center'}
      justifyContent={'space-between'}
      onClick={props.onClick}
      maxW={'100%'}
      h={'55px'}
    >
      <Flex gap={'10px'} alignItems={'center'}>
        <AlertIcon height={'16px'} />
        <Text lineHeight={'11px'} color={'#868E96'} fontWeight={700} fontSize={'10px'}>
          Prescrição com interação <br /> medicamentosa
        </Text>
      </Flex>

      <EditIcon width={15} fill="#868E96" />
    </Flex>
  );
};

export default InteractionBadge;
